import React from 'react';
import ApiDocumentation from '../../component/DashboardApiDocumentation/ApiDocumentation';

const DashboardApiDocumentationContainer = () => {
	return (
		<div className='api-docs-page'>
			<ApiDocumentation />
		</div>
	);
};

export default DashboardApiDocumentationContainer;
